<table class="table table-hover">
  <thead>
    <tr>
      <th>Collection</th>
      <th>Site</th>
    </tr>
  </thead>
  <tbody>
    @for (collection of report().collections; track collection; let i = $index) {
      <tr (click)="toggle(collection)" [class.is-selected]="collection.selected">
        <td><app-tick [selected]="collection.selected ? true : false" />&nbsp; {{ collection.title }}</td>
        <td>{{ collection.siteTitle ?? '' }}</td>
      </tr>
    }
  </tbody>
</table>
